var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8Z",
    fill: "#FF9A32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.581517 10.9999C0.206508 10.0734 0 9.06078 0 7.99988C0 6.93898 0.206508 5.92631 0.581517 4.99988L15.4185 4.99988C15.7935 5.92631 16 6.93898 16 7.99988C16 9.06078 15.7935 10.0734 15.4185 10.9999H0.581517Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4705 10.9998L0.633493 10.9998C1.82027 13.9316 4.6946 15.9998 8.05198 15.9998C11.4094 15.9998 14.2837 13.9316 15.4705 10.9998Z",
    fill: "#28A443"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5Z",
    fill: "#181A93",
    fillOpacity: 0.15,
    stroke: "#181A93"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.75C3.71979 15.75 0.25 12.2802 0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75Z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgIn;